import PropTypes from 'prop-types';
import React, { Component } from 'react';

import {StandardPage} from "../../Common/pages/StandardPage";
import {RightColumn} from "../../Common/pages/RightColumn";

export default class PrivacyPolicyPage extends Component {
  static propTypes = {
    PrivacyPolicy: PropTypes.element,
    PreviousPrivacyPolicy: PropTypes.element,
    location: PropTypes.object.isRequired,
  };

  render() {
    const {
      location,
      PrivacyPolicy,
      PreviousPrivacyPolicy,
    } = this.props;

    return (
      <StandardPage sport="privacy" title="Privacy Policy">
        <div className="main-layout-left-column">
          {PrivacyPolicy}
          {PreviousPrivacyPolicy}
        </div>

        <RightColumn location={location}
                     sport="racing"
                     content={
                       ["topMpu", "bottomMpu", "ocWidget"]} />
      </StandardPage>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/PrivacyPolicy/containers/PrivacyPolicyPage.js